import { create } from 'zustand';

type ScrollState = {
  positions: Record<string, number>;
  save: (tab: string, y: number) => void;
  restore: (tab: string) => number;
};
export const useScrollStore = create<ScrollState>((set, get) => ({
  positions: {},
  save: (tab, y) => set(s => ({ positions: { ...s.positions, [tab]: y } })),
  restore: (tab) => get().positions[tab] ?? 0,
}));
